// extracted by mini-css-extract-plugin
export default {"subCategoriesSelector":"_157x6m2","selectorsDivider":"_10uh7ja"};